import { useState } from 'react';
import useCrmContactStore from '@/stores/CrmContactStore';
import useInboxStore from '@/stores/InboxStore';
import usePlanStore from '@/stores/PlanStore';
import { useShallow } from 'zustand/react/shallow';

import AdvancedFilterSheet from '@/components/common/advanced-filter/AdvancedFilterSheet';

const crmContactFields = [
  {
    _id: 1,
    value: 'full_name',
    label: 'Full Name',
    type: 'text',
  },
  {
    _id: 2,
    value: 'ig_username',
    label: 'IG Username',
    type: 'text',
  },
  {
    _id: 3,
    value: 'bio',
    label: 'Bio',
    type: 'text',
  },
  {
    _id: 4,
    value: 'verified',
    label: 'Is Verified',
    type: 'boolean',
  },
  {
    _id: 5,
    value: 'is_business_account',
    label: 'Is Business Account',
    type: 'boolean',
  },
  {
    _id: 6,
    value: 'profile_picture_url',
    label: 'Profile Picture',
    type: 'boolean',
  },
  {
    _id: 7,
    value: 'post_count',
    label: 'Post Count',
    type: 'number',
  },
  {
    _id: 8,
    value: 'followers_count',
    label: 'Followers Count',
    type: 'number',
  },
  {
    _id: 9,
    value: 'following_count',
    label: 'Following Count',
    type: 'number',
  },
  {
    _id: 10,
    value: 'tag_ids',
    label: 'Tag',
    type: 'enum',
  },
  {
    _id: 11,
    value: 'plan',
    label: 'Plan',
    type: 'enum',
  },
  {
    _id: 12,
    value: 'user_id',
    label: 'Contact Owner',
    type: 'enum',
  },
];

const operatorsList = [
  {
    _id: 1,
    type: 'enum',
    value: 'is_one_of',
    label: 'is one of',
  },
  {
    _id: 2,
    type: 'enum',
    value: 'is_none_of',
    label: 'is none of',
  },
  {
    _id: 3,
    type: 'text',
    value: 'contains',
    label: 'contains',
  },
  {
    _id: 4,
    type: 'text',
    value: 'contains_exactly',
    label: 'contains exactly',
  },
  {
    _id: 5,
    type: 'text',
    value: 'does_not_contain',
    label: 'does not contain',
  },
  {
    _id: 6,
    type: 'boolean',
    value: 'is',
    label: 'is',
  },
  {
    _id: 7,
    type: 'boolean',
    value: 'is_not',
    label: 'is not',
  },
  {
    _id: 8,
    type: 'number',
    value: 'equals',
    label: 'equals',
  },
  {
    _id: 9,
    type: 'number',
    value: 'less_than',
    label: 'less than',
  },
  {
    _id: 10,
    type: 'number',
    value: 'greater_than',
    label: 'greater than',
  },
  {
    _id: 11,
    type: 'number',
    value: 'not_equals',
    label: 'not equals',
  },
];

export default function ContactFilterSheet() {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const { setCrmContactSearchFilter, crmContactSearchFilter } =
    useCrmContactStore(
      useShallow((state) => ({
        crmContactSearchFilter: state.crmContactSearchFilter,
        setCrmContactSearchFilter: state.setCrmContactSearchFilter,
      }))
    );

  const { tags, owners } = useInboxStore(
    useShallow((state) => ({
      tags: state.tags,
      owners: state.owners,
    }))
  );
  const plans = usePlanStore((state) => state.plans);

  // Enum data sources for the filter
  const enumDataSources = {
    tag_ids: tags,
    user_id: owners,
    plan: plans,
  };

  // Custom validation rules
  const validationRules = {
    tag_ids: (value) => Array.isArray(value) && value.length > 0,
    plan: (value) => Array.isArray(value) && value.length > 0,
    user_id: (value) => Array.isArray(value) && value.length > 0,
  };

  return (
    <AdvancedFilterSheet
      isOpen={isFilterOpen}
      onOpenChange={setIsFilterOpen}
      filters={crmContactSearchFilter}
      onFiltersChange={setCrmContactSearchFilter}
      title='Advanced Filters'
      triggerButtonText='Advanced Filter'
      fieldList={crmContactFields}
      enumDataSources={enumDataSources}
      validationRules={validationRules}
      operatorsList={operatorsList}
    />
  );
}
